import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface MoveToOfferConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending: boolean;
}

export function MoveToOfferConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending,
}: MoveToOfferConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[460px]">
        <DialogHeader>
          <DialogTitle>Move candidate to Offer?</DialogTitle>
          <DialogDescription>
            This marks that an offer is being extended. The candidate&apos;s status will switch to{' '}
            <strong>Hiring</strong> and they will appear in the Offer column for the hiring team.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
            Cancel
          </Button>
          <Button variant="accent" onClick={onConfirm} disabled={isPending}>
            {isPending ? 'Saving...' : 'Move to Offer'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
